import { Outlet } from 'react-router-dom';

import Header from '../../components/Header';

import WorkItemsNav from './WorkItemsNav';

/**
 * Parent shell for the Work items tool. Renders the header, the sub-tab strip,
 * and the active child scene via `<Outlet />` — the items themselves, and the
 * schedules that emit them. The shell is intentionally thin: each sub-tab is
 * its own scene, with its own filters and paging.
 */
const WorkItemsScene = () => (
  <div className="bg-bg-primary text-fg-primary flex min-h-screen flex-col">
    <Header />
    <main className="flex flex-1 flex-col gap-4 px-6 py-5">
      <h1 className="text-sm font-semibold uppercase tracking-widest">Work items</h1>
      <WorkItemsNav />
      <Outlet />
    </main>
  </div>
);

export default WorkItemsScene;
